/* istanbul ignore file */

import React from 'react';
import { connect } from 'react-redux';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import {
  type BreadcrumbLinkClickPayload,
  Breadcrumbs,
} from '@noths/polaris-client-ribbons-design-system';

import type { BreadcrumbsContainerStateProps } from 'src/components/molecules/Breadcrumbs/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getBreadcrumbsLinksForProduct } from 'src/utils/getBreadcrumbs';

export const mapStateToProps = (state: ReduxApplicationState): BreadcrumbsContainerStateProps => {
  const breadcrumbs = getBreadcrumbsLinksForProduct(state.product, state.user.featureFlags);

  return {
    breadcrumbsLinks: breadcrumbs.map(({ rel, title }) => ({
      rel: rel,
      text: title,
    })),
  };
};

const Container = ({ breadcrumbsLinks }: BreadcrumbsContainerStateProps) => {
  const onLinkClick = (
    e: React.MouseEvent | React.MouseEvent<HTMLAnchorElement>,
    { linkDepth }: BreadcrumbLinkClickPayload,
  ) => {
    return sendGALinkClickEvent(e, {
      event: 'custom_event',
      event_action: 'Link Click',
      event_category: 'Breadcrumb',
      event_label: `${linkDepth} Level(s) Up`,
      destination_URL: (e.currentTarget as HTMLAnchorElement).href,
    });
  };

  return <Breadcrumbs links={breadcrumbsLinks} onLinkClick={onLinkClick} />;
};

export const BreadcrumbContainer = connect(mapStateToProps)(Container);
